// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2NmvJ","productName":"Table_productName__1evzu"};